import React from "react";
import {useTranslation} from "react-i18next";

interface DialogCloseButtonProps {
    onClose: () => void;
}

function DialogCloseButton({onClose}: DialogCloseButtonProps) {
    const {t} = useTranslation();
    return (
        <button
            type="button"
            className="dialog-close-button"
            onClick={onClose}
            aria-label={t("common.button.close")}
        >
            &times;
        </button>
    )
}

export default DialogCloseButton;